interface Props {
  t: (key: string) => string;
}

export function Manifesto({ t }: Props) {
  const body = t('manifesto.body');
  const strong = t('manifesto.body.strong');
  const html = strong ? body.replace(strong, `<strong>${strong}</strong>`) : body;

  return (
    <section className="section" id="modelo">
      <div className="container">
        <div className="section-head reveal">
          <div className="label-row mono">
            <span className="num">02</span>
            <span>{t('manifesto.label')}</span>
            <span className="bar"></span>
          </div>
          <h2 className="h2">
            {t('manifesto.h2.a')} <span className="em">{t('manifesto.h2.em')}</span>
          </h2>
        </div>

        <div className="manifesto reveal">
          <p dangerouslySetInnerHTML={{ __html: html }} />
          <div className="sig mono">{t('manifesto.sig')}</div>
        </div>
      </div>
    </section>
  );
}
